import { defineStore } from "pinia";
import type IItemWithSignatureRaw from "@/models/IItemWithSignatureRaw";

export const useItemLabelsStore = defineStore("itemlabels", {
  state: () => {
    return { signatureItems: [] as IItemWithSignatureRaw[] };
  },
  actions: {
    setSignatureItems(sms: IItemWithSignatureRaw[]) {
      this.signatureItems = sms;
    },
    addSignatureItem(sigMat: IItemWithSignatureRaw) {
      this.signatureItems.push(sigMat);
    },
    removeSignatureItem(sigMat: IItemWithSignatureRaw) {
      const index = this.signatureItems.findIndex(
        (m) =>
          m.item.id === sigMat.item.id &&
          m.lot === sigMat.lot &&
          m.bestBefore === sigMat.bestBefore &&
          m.expiry === sigMat.expiry
      );
      this.signatureItems.splice(index, 1);
    },
    clearSignatureItems() {
      this.signatureItems = [];
    },
    getSignatureItems() {
      return this.signatureItems;
    },
    isStored(sigMat: IItemWithSignatureRaw) {
      return this.signatureItems.some(
        (m) =>
          m.item.id === sigMat.item.id &&
          m.lot === sigMat.lot &&
          m.bestBefore === sigMat.bestBefore &&
          m.expiry === sigMat.expiry
      );
    },
  },
});
